






























































import Vue from 'vue'
import Loader from '@/components/Global/Loader.vue'
import { batteryStates, gpsStates, networkStates } from '@/components/InstallDevices/constants'
import { apiGetLocationUpdate, apiLiveUpdatesEndpoint } from '@/api'
import { mutations, portalState } from '@/state'
import { tracefyBlue } from '@/plugins/vuetify'

const liveUpdateStates = {
  CONNECTING: 'connecting',
  CONNECTED: 'connected',
  ERROR: 'error',
  LIVE: 'live'
}
const { GPS_STRONG_CONNECTION, GPS_MEDIUM_CONNECTION, GPS_WEAK_CONNECTION } = gpsStates
const { NETWORK_CONNECTED, NETWORK_DISCONNECTED } = networkStates
const { BATTERY_CONNECTED, BATTERY_DISCONNECTED } = batteryStates
const { CONNECTED, CONNECTING, LIVE, ERROR } = liveUpdateStates

export default Vue.extend({
  name: 'DebugTab',
  components: { Loader },
  props: {
    entity: Object,
    noPastLocation: Boolean
  },
  computed: {
    computedBatteryState () {
      switch (this.batteryState) {
        case BATTERY_CONNECTED:
          return { icon: 'far fa-battery-bolt', color: 'success', tooltip: '  externalBatteryConnected' }
        default:
          return { icon: 'far fa-battery-slash', color: 'danger', tooltip: '  externalBatteryDisconnected' }
      }
    },
    computedNetworkState () {
      switch (this.networkState) {
        case NETWORK_CONNECTED:
          return { icon: 'far fa-signal-alt', color: 'success', tooltip: 'networkConnected' }
        default:
          return { icon: 'far fa-signal-alt-slash', color: 'danger', tooltip: 'networkDisconnected' }
      }
    },
    computedGPSState () {
      switch (this.gpsState) {
        case GPS_STRONG_CONNECTION:
          return { icon: 'far fa-satellite', color: 'success', tooltip: 'strongGps' }
        case GPS_MEDIUM_CONNECTION:
          return { icon: 'far fa-satellite', color: 'warning', tooltip: 'mediumGps' }
        default:
          return { icon: 'far fa-satellite', color: 'danger', tooltip: 'weakGps' }
      }
    }
  },
  data () {
    return {
      modalActive: false,
      liveUpdateState: CONNECTING,
      eventStream: null,
      customerEntity: true,
      showRequestLocationUpdate: false,
      mapOptions: { maxZoom: 20, minZoom: 3, disableDefaultUI: true },
      positionedAt: null,
      updateFromNow: null,
      updateTimeInterval: null,
      errorCallback: null,
      margin: 100,
      speed: 0,
      heading: 0,
      networkState: NETWORK_CONNECTED,
      gpsState: GPS_STRONG_CONNECTION,
      batteryState: BATTERY_CONNECTED,
      liveUpdateStates,
      tracefyBlue
    }
  },
  methods: {
    timeBasedFunctionalityHandler () {
      const now = this.$moment(new Date())
      const duration = this.$moment.duration(now.diff(this.$moment(this.positionedAt)))
      const minutes = duration.asMinutes()
      if (minutes > 3) {
        this.networkState = NETWORK_DISCONNECTED
      } else if (minutes > 1) {
        this.showRequestLocationUpdate = true
      } else {
        this.showRequestLocationUpdate = false
      }
    },
    connectToStream () {
      this.eventStream = new EventSource(`${apiLiveUpdatesEndpoint}/real-time/status?imei=${this.entity.imei}&bearer=${portalState.bearer}`)
      this.eventStream.onopen = () => {
        this.liveUpdateState = CONNECTED
        this.errorCallback = null
      }
      this.eventStream.onerror = () => {
        console.log('Node live updates service has an error or you are timed out and attempting to reconnect')
      }
      this.eventStream.onmessage = (m: any) => {
        const [_, position, positionedAt, margin, speed, direction, batteryState, satellites] = JSON.parse(m.data)
        this.$emit('locationUpdate', { position, positionedAt, margin })

        this.entityPosition = position
        this.positionedAt = positionedAt

        if (this.updateTimeInterval) {
          clearInterval(this.updateTimeInterval)
        }

        this.showRequestLocationUpdate = false

        this.updateTimeInterval = setInterval(() => {
          this.updateFromNow = this.$moment.utc(this.positionedAt).fromNow()
          this.timeBasedFunctionalityHandler()
        }, 10000)

        this.liveUpdateState = LIVE
        this.updateFromNow = this.$moment.utc(positionedAt).fromNow()
        this.batteryState = batteryState ? BATTERY_CONNECTED : BATTERY_DISCONNECTED
        this.networkState = NETWORK_CONNECTED
        if (satellites > 6) {
          this.gpsState = GPS_STRONG_CONNECTION
        } else if (satellites > 1) {
          this.gpsState = GPS_MEDIUM_CONNECTION
        } else {
          this.gpsState = GPS_WEAK_CONNECTION
        }

        this.margin = margin
        this.speed = speed
        this.direction = direction
      }
    },
    requestLocationUpdate (id: string) {
      apiGetLocationUpdate(id).then(() => {
        this.showRequestLocationUpdate = false
        clearInterval(this.updateTimeInterval)
        mutations.setSnackbar('success', this.t({s: 'success', component: 'Snackbar'}))
      }).catch(e => {
        mutations.setSnackbar('error', e.response.data.message)
      })
    }
  },
  mounted () {
    this.connectToStream()
  },
  beforeDestroy () {
    this.eventStream.close()
    clearInterval(this.updateTimeInterval)
    clearTimeout(this.errorCallback)
  }
})

